import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import classNames from 'classnames';
import styles from './fieldset.scss';
export const Fieldset = _ref => {
  let {
    id,
    ariaLabelledBy,
    className,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("fieldset", _extends({
    id: id,
    "aria-labelledby": ariaLabelledBy,
    className: classNames(styles.fieldset, className)
  }, rest));
};
//# sourceMappingURL=fieldset.js.map